import { render } from "./TheHeaderLangIcon.vue?vue&type=template&id=b8d46c9c&scoped=true&ts=true"
import script from "./TheHeaderLangIcon.vue?vue&type=script&lang=ts"
export * from "./TheHeaderLangIcon.vue?vue&type=script&lang=ts"

import "./TheHeaderLangIcon.vue?vue&type=style&index=0&id=b8d46c9c&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d46c9c"]])

export default __exports__